
import {  Component,FormPageMixins,Mixins,appConst,PageResultModalMixins } from "@/lib";
import CreateFacotyCost from"./create-factorycost.vue";
import Factorycost from "@/store/modules/shipment/factorycost/entity";
import FactorycostEntity from "@/store/modules/shipment/factorycost/factoryentity";
import CardTitleView from "@/components/card-title/index.vue"
@Component({
    components:{CreateFacotyCost,CardTitleView}
})
export default class RegistrationFactorycostView extends  Mixins(FormPageMixins, PageResultModalMixins) {
     model:Factorycost = new Factorycost();
     securityItem:any;//选项明细集合（弹框用）
async created() {

            Object.assign(this.config,{
            getAction: "shipment/factorycost/get",
           //  labelWidth:220,
            pageTitleL:"app.FactoryCost.Registration",
            okAction:"shipment/factorycost/create",
            isRedirectIndex:true

        })
  }
  
  get record(){
        return this.$store.state.shipment.factorycost.editFactoryCost;
    }
    
    securityColumn = [
        {
            title: this.L('app.FactoryCost.SerialNumber'),
            slot: 'serialNumber',
            key: 'serialNumber',
            width: 100
          },
          {
            title: this.L('app.FactoryCost.FactoryName'),
            slot: 'factoryName',
            key: 'factoryName',
            minwidth: 120
          },
          {
                title: this.L("app.FactoryCost.Amount"),
                key: "amount",
                width: 150,
                render: (h: any, params: any) => {
                return [h("span", this.$util.format.amount(params.row.amount))];
                },
          },
          {
            title: this.L('app.FactoryCost.Remark'),
            slot: 'remark',
            key: 'remark'
          },
          {
            title: this.L('Action.Actions'),
            slot: 'action',
            key: 'action',
            width: 120
          }
    ];
    
       addSecurityCheckItem(){
           this.securityItem = new FactorycostEntity;
           this.$store.commit("shipment/factorycost/setSecurityItem", {securityItem: this.securityItem});
           this.open("factory-dlg");
    }
    async getSecurityCheckItem(Item){
        
        if(Item._index == undefined)
        {
            this.model.recordDto.push(Item);
        }
        else
        {
            
            Object.assign(this.model.recordDto[Item._index], Item)
        }

        this.model.recordDto;
    }
    async securityDelete(index) {
        this.model.recordDto.splice(index,1);
    }
     async securityEdit (row, index) {
        this.securityItem = row;
        this.$store.commit("shipment/factorycost/setSecurityItem", {securityItem: this.securityItem});

        this.open("factory-dlg");
    }
    get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
    handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.FactoryCost.SubTotal');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0||index===3 ||index===4||index===5 ) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            sums[key] = {
                key,
                value: key === "amount" ? this.$util.format.amount(v) : v
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }
    
  
}


